import * as s from '~js/utils/selectors';
import * as a from '~js/utils/attributes';
import * as c from '~js/utils/classes';

export class HoverDisclosure {
  constructor(el) {
    this.disclosure = el;
    this.header = el.closest(s.selectors$C.header);
    this.key = this.disclosure.id;
    this.trigger = document.querySelector(`[${a.attributes$n.disclosureToggle}='${this.key}']`);
    this.link = this.trigger.querySelector(s.selectors$C.link);
    this.grandparent = this.trigger.classList.contains(c.classes$s.grandparent);
    this.background = document.querySelector(s.selectors$C.headerBackground);
    this.trigger.setAttribute(a.attributes$n.ariaHasPopup, true);
    this.trigger.setAttribute(a.attributes$n.ariaExpanded, false);
    this.trigger.setAttribute(a.attributes$n.ariaControls, this.key);
    this.dropdown = this.trigger.querySelector(s.selectors$C.disclosureWrappper);
    this.setBackgroundHeightEvent = () => this.setBackgroundHeight();

    this.connectHoverToggle();
    this.handleTablets();
  }

  setBackgroundHeight() {
    this.hasScrolled = document.body.classList.contains(c.classes$s.hasScrolled);
    this.headerHeight = this.hasScrolled ? window.stickyHeaderHeight : this.header.offsetHeight;

    if (this.grandparent) {
      this.dropdown.style.height = 'auto';
      this.dropdownHeight = this.dropdown.offsetHeight + this.headerHeight;
    } else {
      this.dropdownHeight = this.headerHeight;
    }

    this.background.style.setProperty('--header-background-height', `${this.dropdownHeight}px`);

    // Hide header dropdowns on mobile
    if (window.innerWidth < theme.sizes.small) {
      this.hideDisclosure();
    }
  }

  showDisclosure() {
    this.setBackgroundHeight();
    document.addEventListener('theme:resize', this.setBackgroundHeightEvent);

    // Set accessibility and classes
    this.trigger.setAttribute(a.attributes$n.ariaExpanded, true);
    this.trigger.classList.add(c.classes$s.isVisible);
    this.header.classList.add(c.classes$s.headerMenuOpened);
    if (this.trigger.classList.contains(c.classes$s.grandparent)) {
      document.dispatchEvent(new CustomEvent('theme:scroll:lock', { bubbles: true, detail: this.header }));
    }
    this.updateHeaderHover();
  }

  hideDisclosure() {
    this.background.style.removeProperty('--header-background-height');
    document.removeEventListener('theme:resize', this.setBackgroundHeightEvent);

    this.trigger.classList.remove(c.classes$s.isVisible);
    this.trigger.setAttribute(a.attributes$n.ariaExpanded, false);
    this.header.classList.remove(c.classes$s.headerMenuOpened);
    if (!document.body.classList.contains(c.classes$s.searchOpened)) {
      document.dispatchEvent(new CustomEvent('theme:scroll:unlock', { bubbles: true }));
    }
  }

  updateHeaderHover() {
    requestAnimationFrame(() => {
      const isHovered = this.header.matches(':hover');
      const hasHoveredClass = this.header.classList.contains(c.classes$s.headerHovered);

      if (isHovered && !hasHoveredClass) this.header.classList.add(c.classes$s.headerHovered);
    });
  }

  handleTablets() {
    // first click opens the popup, second click opens the link
    this.trigger.addEventListener('touchstart', (e) => {
      const isOpen = this.trigger.classList.contains(c.classes$s.isVisible);
      if (!isOpen) {
        e.preventDefault();

        // Hide the rest of the active nav items
        const activeNavItems = this.header.querySelectorAll(`.${c.classes$s.isVisible}${s.selectors$C.navItem}`);

        if (activeNavItems.length > 0) {
          activeNavItems.forEach((item) => {
            if (item !== this.trigger) {
              item.dispatchEvent(new Event('mouseleave', { bubbles: true }));

              const onTransitionEnd = () => {
                requestAnimationFrame(() => {
                  this.showDisclosure();
                });

                item.removeEventListener('transitionend', onTransitionEnd);
              };

              item.addEventListener('transitionend', onTransitionEnd);
            }
          });

          return;
        }

        this.showDisclosure();
      }
    });
  }

  connectHoverToggle() {
    this.trigger.addEventListener('mouseenter', () => this.showDisclosure());
    this.link.addEventListener('focus', () => this.showDisclosure());

    this.trigger.addEventListener('mouseleave', () => this.hideDisclosure());
    this.trigger.addEventListener('focusout', (event) => {
      const inMenu = this.trigger.contains(event.relatedTarget);

      if (!inMenu) {
        this.hideDisclosure();
      }
    });
    this.disclosure.addEventListener('keyup', (event) => {
      if (event.code !== theme.keyboardKeys.ESCAPE) {
        return;
      }
      this.hideDisclosure();
    });
  }

  onBlockSelect(event) {
    if (this.disclosure.contains(event.target)) {
      this.showDisclosure(event);
    }
  }

  onBlockDeselect(event) {
    if (this.disclosure.contains(event.target)) {
      this.hideDisclosure();
    }
  }
}